export default "__VITE_ASSET__150e17a6__"